import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesReportsProverkaMain } from './modules/ui/Main';

const ReportsProverkaPage = (
  <SuspensePage>
    <PagesReportsProverkaMain />
  </SuspensePage>
);

export default ReportsProverkaPage;
